import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface ITicketDuzenle_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITicketDuzenle_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  DepartmanlarGetir: any[];
  DepartmanlarGetir_dummy: any[];
  TeknikMasaMusteriGetir: any[];
  TeknikMasaMusteriGetir_dummy: any[];
  GetSisyaKullaniciDetay: any[];
  GetSisyaKullaniciDetay_dummy: any[];
  GetTicketDetay: any[];
  GetTicketDetay_dummy: any[];
  EditTicketDetailByID: number;
  EditTicketDetailByID_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  SistemLogEkle: number;
  SistemLogEkle_dummy: number;
  NAVIGATE: any;
  NAVIGATE_dummy: any;

  isMasterPageInitLoaded?: boolean;
  isMasterPageRecurringLoaded?: boolean;
  shouldTriggerPageInit?: boolean;
}

export class TicketDuzenle_ScreenBase extends React.PureComponent<ITicketDuzenle_ScreenProps, any> {
  ticketduzenle_909609_value_kuikaSelectBoxRef: React.RefObject<any>;
  ticketduzenle_804729_value_kuikaNoneRef: React.RefObject<any>;
  ml = [
    {
      Id: "0140ac25-79e8-4970-bae8-db8c55d4bd78",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: []
    },
    {
      Id: "20349670-0917-4cda-a42c-16f5313466a1",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 841578, PropertyName: "value", Value: "Ticket Düzenle" },
        { Id: 858068, PropertyName: "value", Value: "Bu sayfada ticket detaylarını güncelleyebilirsiniz" },
        { Id: 255486, PropertyName: "placeholder", Value: "Sorun Başlığı" },
        { Id: 909609, PropertyName: "placeholder", Value: "Müşteri" },
        { Id: 335332, PropertyName: "label", Value: "Kaydet" }
      ]
    }
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.ticketduzenle_255486_value_kuikaTextInputRef = React.createRef();
    this.ticketduzenle_909609_value_kuikaSelectBoxRef = React.createRef();
    this.ticketduzenle_804729_value_kuikaNoneRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      DepartmanlarGetir: [],
      TeknikMasaMusteriGetir: [],
      GetSisyaKullaniciDetay: [],
      GetTicketDetay: [],
      EditTicketDetailByID: 0,
      Notify: false,
      SistemLogEkle: 0,
      NAVIGATE: "",

      isMasterPageInitLoaded: false,
      isMasterPageRecurringLoaded: false,
      shouldTriggerPageInit: false
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("ticketduzenle", "masterekran_screen");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.TicketDuzenlePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("ticketduzenle", "masterekran_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("ticketduzenle", "masterekran_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TicketDuzenlePageInit();
    }

    if (
      prevState.isMasterPageInitLoaded !== this.state.isMasterPageInitLoaded &&
      this.state.isMasterPageInitLoaded === true
    ) {
      await this.TicketDuzenlePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (key.startsWith("NavVisible") && prevState[key] === true && this.state[key] === false) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  setMasterPageInitLoaded = (value: boolean) => {
    this.setState({ isMasterPageInitLoaded: value });
  };

  setMasterPageRecurringLoaded = (value: boolean) => {
    this.setState({ isMasterPageRecurringLoaded: value });
  };
  setShouldTriggerPageInit = (value: boolean) => {
    this.setState({ shouldTriggerPageInit: value });
  };

  TicketDuzenlePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    let localVar = {
      KullaniciAdi_2: ReactSystemFunctions.convertToTypeByName(ReactSystemFunctions.getMyUsername(), "string"),
      ID_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TicketID ?? this.props.screenInputs.ticketid,
        "number"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "TicketDuzenle/TicketDuzenlePageInit", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DepartmanlarGetir = result?.data.departmanlarGetir;
    stateVars.TeknikMasaMusteriGetir = result?.data.teknikMasaMusteriGetir;

    formVars.ticketduzenle_909609_value =
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].musteri
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].musteri
        : null;
    formVars.ticketduzenle_909609_options = stateVars.TeknikMasaMusteriGetir;
    stateVars.GetSisyaKullaniciDetay = result?.data.getSisyaKullaniciDetay;
    stateVars.GetTicketDetay = result?.data.getTicketDetay;
    formVars.ticketduzenle_255486_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].baslik
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].baslik
        : null
    );
    formVars.ticketduzenle_909609_value =
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].musteri
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].musteri
        : null;
    formVars.ticketduzenle_909609_options = stateVars.TeknikMasaMusteriGetir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TicketDuzenlePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TicketDuzenlePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    formVars.ticketduzenle_255486_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].baslik
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].baslik
        : null
    );

    formVars.ticketduzenle_909609_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].musteri
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].musteri
        : null
    );

    stateVars.dataSource_909609 = this.state.TeknikMasaMusteriGetir;
    stateVars.dataSource_909609 = this.state.TeknikMasaMusteriGetir;
    formVars.ticketduzenle_318909_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTicketDetay !== undefined
        ? stateVars.GetTicketDetay?.length > 0
          ? stateVars.GetTicketDetay[0].aciklama
          : null
        : this.state.GetTicketDetay?.length > 0
        ? this.state.GetTicketDetay[0].aciklama
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TicketDuzenleComponent_335332_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Aciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ticketduzenle_318909_value", "value", "", "", "")
        ),
        "string"
      ),
      Baslik_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ticketduzenle_255486_value", "value", "", "", "")
        ),
        "string"
      ),
      Departman_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSisyaKullaniciDetay !== undefined
            ? stateVars.GetSisyaKullaniciDetay?.length > 0
              ? stateVars.GetSisyaKullaniciDetay[0].departman
              : null
            : this.state.GetSisyaKullaniciDetay?.length > 0
            ? this.state.GetSisyaKullaniciDetay[0].departman
            : null
        ),
        "string"
      ),
      Dosya_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "ticketduzenle_804729_value", "fileId", "", "", "")
        ),
        "string"
      ),
      DosyaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "ticketduzenle_804729_value", "fileName", "", "", "")
        ),
        "string"
      ),
      Musteri_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(this, "ticketduzenle_909609_value", "value", "TeknikMasaMusteriGetir", "ad", "ad")
        ),
        "string"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TicketID ?? this.props.screenInputs.ticketid,
        "number"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TicketDuzenle/TicketDuzenleComponent_335332_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.EditTicketDetailByID = result?.data.editTicketDetailByID;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TicketDuzenleComponent_335332_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TicketDuzenleComponent_335332_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "9fb8bd92_c611_fee2_2f11_0ad41f0e119c_notify",
        this.defaultML,
        "İşlem Başarıyla Tamamlanmıştır."
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TicketDuzenleComponent_335332_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TicketDuzenleComponent_335332_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Aktivite_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Bir ticket düzenlendi.", "string"),
        "string"
      ),
      Kullanici_0: ReactSystemFunctions.convertToTypeByName(ReactSystemFunctions.getMyUsername(), "string")
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TicketDuzenle/TicketDuzenleComponent_335332_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SistemLogEkle = result?.data.sistemLogEkle;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TicketDuzenleComponent_335332_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TicketDuzenleComponent_335332_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TicketDuzenle",
      "HomePage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["TicketDuzenle"] ?? false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.TicketDuzenlePageInit();
    } else if (window.kuika?.serverRequestCount > 0 && pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TicketDuzenlePageInit();
    }
  }
}
